import {
  createContext,
  useContext,
  useMemo,
  useState,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
} from 'react';

interface MessengerNavbarStackContextValue {
  overlayAnchorEl: HTMLElement | null;
  setOverlayAnchorEl: Dispatch<SetStateAction<HTMLElement | null>>;
}

const MessengerNavbarStackContext = createContext<MessengerNavbarStackContextValue | null>(null);

export function MessengerNavbarStackProvider({ children }: { children: ReactNode }) {
  const [overlayAnchorEl, setOverlayAnchorEl] = useState<HTMLElement | null>(null);
  const value = useMemo(
    () => ({ overlayAnchorEl, setOverlayAnchorEl }),
    [overlayAnchorEl]
  );

  return (
    <MessengerNavbarStackContext.Provider value={value}>
      {children}
    </MessengerNavbarStackContext.Provider>
  );
}

export function useMessengerNavbarStack(): MessengerNavbarStackContextValue {
  const ctx = useContext(MessengerNavbarStackContext);
  if (!ctx) {
    throw new Error('useMessengerNavbarStack must be used within MessengerNavbarStackProvider');
  }
  return ctx;
}
